angular.module('CarsSaraBo').directive('saraSwitch', function () {
	return {
		restrict: 'E',
		controller: [SwitchController],
		controllerAs: 'ctrl',
		bindToController: {
			disabled: '&',
			model: '&',
			onClick: '&',
            mediumSize: '&?' // EVA provides two possible size: small (Default) or medium.
        },
		templateUrl: 'templates/commons/switch/switch.component.html',
		scope: {} // isolated scope
	};
});

function SwitchController() {
	var vm = this;

    vm.toggle = function (event) {
		event.preventDefault();
		vm.onClick();
    }
}


//////////////////
// WEBPACK FOOTER
// ./public/app/commons/switch/switch.component.js
// module id = 925
// module chunks = 3